
export enum SupportedFileContentType {
  STL = '.stl',
  MATAMX = '.matamx',
  ZIP = '.zip'
}
